// extracted by mini-css-extract-plugin
module.exports = {"pdf":"styles_pdf__O6pkE","card":"styles_card__2tncx","signature":"styles_signature__24eqs"};